export default __webpack_public_path__ + "static/media/Regional_on_light_blue.4470b8a8.svg";